module.exports = __webpack_public_path__ + "img/ibaje.4aadee37.png";